var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("spinner", { attrs: { "is-loading": _vm.isLoadingContainer } }),
      _c("div", { staticClass: "is-fluid" }, [
        _c(
          "div",
          { staticClass: "container", attrs: { id: "filter-content" } },
          [
            _c(
              "b-field",
              {
                attrs: {
                  grouped: "",
                  "group-multiline": "",
                  position: "is-centered",
                },
              },
              [
                _vm.showInvestorFilter
                  ? _c(
                      "b-field",
                      { attrs: { "custom-class": "has-text-weight-normal" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: {
                              id: "select-investor",
                              size: "is-small",
                              name: "investor",
                              expanded: "",
                              rounded: "",
                            },
                            model: {
                              value: _vm.filterInvestorId,
                              callback: function ($$v) {
                                _vm.filterInvestorId = $$v
                              },
                              expression: "filterInvestorId",
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                domProps: {
                                  value: _vm.defaultInvestorSelected,
                                },
                              },
                              [_vm._v("Elige un inversionista")]
                            ),
                            _vm._l(_vm.investors, function (investor) {
                              return _c(
                                "option",
                                {
                                  key: investor._id,
                                  domProps: { value: investor._id },
                                },
                                [_vm._v(" " + _vm._s(investor.name) + " ")]
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showInvestorFilter
                  ? _c(
                      "b-field",
                      { attrs: { "custom-class": "has-text-weight-normal" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass:
                              "button perform-filter is-button-secondary is-rounded",
                            attrs: {
                              id: "operation-filter-button",
                              size: "is-small",
                              disabled: !_vm.checkUserFeature(
                                "element.my-portfolios.button.filtrar"
                              ),
                            },
                            on: { click: _vm.getOperations },
                          },
                          [
                            _c("span", { staticClass: "icon is-small" }, [
                              _c("i", { staticClass: "fas fa-filter" }),
                            ]),
                            _c("span", [_vm._v("Filtrar")]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.operationListFromService.length > 0
                  ? _c(
                      "b-field",
                      { attrs: { id: "operation-filter" } },
                      [
                        _c("b-input", {
                          attrs: {
                            id: "search-input",
                            type: "search",
                            icon: "search",
                            "icon-clickable": "",
                            placeholder: "Número de Operación",
                            size: "is-small",
                            rounded: "",
                          },
                          on: {
                            input: _vm.filterOperation,
                            blur: function ($event) {
                              return _vm.sendFilterAction("filter")
                            },
                          },
                          model: {
                            value: _vm.searchInputVal,
                            callback: function ($$v) {
                              _vm.searchInputVal = $$v
                            },
                            expression: "searchInputVal",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("spinner", { attrs: { "is-loading": _vm.isLoading } }),
      _vm.isErrorMessage
        ? _c(
            "div",
            {
              staticClass:
                "operation-process-info has-text-centered error-message",
              attrs: { id: "operation-error-title" },
            },
            [_c("span", [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")])]
          )
        : _vm._e(),
      _vm.operationList.length
        ? _c(
            "div",
            {
              staticClass:
                "message-process-info has-text-centered transaction-details",
            },
            [
              _c(
                "div",
                {
                  staticClass: "message-text",
                  attrs: { id: "message-process-title" },
                },
                [
                  _vm.operationList.length
                    ? _c("span", [
                        _vm._v(" La búsqueda arrojó un total "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.operationList.length) + " operacion(es) "
                          ),
                        ]),
                        _vm._v(". "),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.operationList.length
        ? _c(
            "div",
            {
              staticClass:
                "message-process-info has-text-centered transaction-details",
            },
            [
              _c(
                "div",
                {
                  staticClass: "message-text",
                  attrs: { id: "message-process-title" },
                },
                [
                  _c("span", [
                    _vm._v(" Le pertenece(n) "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.operationListActualDueDate.length) +
                          " operacion(es) "
                      ),
                    ]),
                    _vm._v(" con cuota a vencer el "),
                    _c("strong", [_vm._v(_vm._s(_vm.actualDueDate))]),
                    _vm._v(". "),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.operationList.length
        ? _c(
            "div",
            {
              staticClass: "operation-details",
              attrs: {
                id: "operation-list",
                name: "operation-list",
                appear: "",
                tag: "div",
              },
            },
            _vm._l(_vm.operationList, function (operationItem, i) {
              return _c(
                "div",
                {
                  key: `${operationItem}-${i}`,
                  staticClass: "padding-top",
                  style: { "--i": i },
                  attrs: { id: `item-${i}` },
                },
                [
                  _c("operation-item", {
                    attrs: {
                      operation: operationItem,
                      "investors-ids": _vm.investorsIds,
                      pos: i,
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }